import Tenants from '../features/tenants';

export const TenantsPage = () => <Tenants />;
